const TableHeader = () => {
    return ( 
        <thead>
            <tr>
                <th>ID</th>
                <th>дата</th>
                <th>продукт</th>
                <th>имя</th>
                <th>email</th>
                <th>телефон</th>
                <th>статус</th>
                <th></th>
            </tr>
        </thead>
    );
}
 
export default TableHeader;